import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import { 
    btnListaPresentaciones
  } from "../../../store/precios/precios/actions";

import { 
    SET_ARREGLO
  } from "../../../store/precios/precios/types";
import { FieldSet } from '@sigeco/tools';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from "@material-ui/core/Button";
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    columnImage: {
        flex: 1,
        fontSize: '.8125rem',
    },
    columnIndex: {
        fontSize: '.8125rem',
        width: '3.5rem'
    },
    columnText: {
        fontSize: '.8125rem',
        width: '12rem'
    },
    empty: {
        marginTop: '1rem',
        textAlign: 'center'
    },
    image: {
        backgroundColor: '#fff',
        border: 'solid 1px #d3d3d3',
        borderRadius: '50%',
        objectFit: 'contain',
        height: '3.25rem',
        width: '3.25rem'
    },
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        overflowY: 'hidden'
    },
    row: {
        alignItems: 'center',
        borderBottom: 'solid 1px #d3d3d3',
        display: 'flex',
        padding: '.5rem 2rem',
        '&:hover' : {
            backgroundColor : '#f3f3f3'
        },
        '&:first-child': {
            borderTop: 'solid 1px #d3d3d3'
        },
        '&:focus': {
            border: 'solid 1px #006bb6',
            outline: 'none'
        }
    },
    tableWrap: {
        flex: '1 1 auto',
        overflowY: 'auto',
        padding: '1rem 0'
    },
    table1: {
        marginLeft: "200px !important",
        "@media (max-width: 390px)": {
            marginLeft: "30px !important",
            width: '85%'
        },

        "@media (max-width: 393px)": {
            marginLeft: "30px !important",
            width: '85%'
        },
        
        // "@media only screen" :{ 
        //    ' and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)': {
        //     /* Estilos específicos para el iPhone 11 */
        //     marginLeft: "30px !important",
        //     width: '85% !important' 
        // },
        //}

        "@media (max-width: 414px)": {
            marginLeft: "30px !important",
            width: '85%'
        },

        "@media (max-width: 430px)": {
            marginLeft: "30px !important",
            width: '85%'
        },

        "@media (max-width: 428px)": {
            marginLeft: "30px !important",
            width: '85%'
        },
        
    }
}));

const PreciosTable = () => {
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const store = useSelector(state => state.precios.store);
    const arreglo = useSelector(state => state.precios.arreglo);
    const position = useSelector(state => state.precios.aux);
    const clear = useSelector(state => state.precios.clearArreglo);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [presentaciones, setPresentaciones] = useState([]);
    

    //console.log("SSSS", store.aMarcas)

    //console.log("pre: ", presentaciones)

    const [presentacionAux, setpresentacionAux] = useState({
        dPresentacion: '',
        detalle: '',
        precioCompra:'',
        precioVenta:'',
        uriFoto:'',
        index:0
    }); 

    useEffect(() => {
    if(clear === true)
        {
            setPresentaciones([]);
            //presentaciones = [];
            //console.log("arreglo: ",presentaciones);
            //console.log("arregloAux: ",presentacionAux);

            setMostrarFormulario(false);
            dispatch({type: SET_ARREGLO, clearArreglo: false});
        }
    },[clear]);

    useEffect(() => {

        

        
        if(store.aPrestaciones != undefined){
        const ax = [...store.aPrestaciones];
  
        if (presentaciones.length === 0) {
          const updatedMarcas = ax.map(item => ({
            dPresentacion: item.dPresentacion,
            presentacionId: item.presentacionId,
            detalle: item.detalle,
            precioCompra: item.precioCompra,
            uriFoto:'',
            precioVenta:'',
            
            
          }));
          setPresentaciones(updatedMarcas);
          position.agregar = true;
        } else {
          const updatedMarcas = presentaciones.concat(ax.map(item => ({
            dPresentacion: item.dPresentacion,
            presentacionId: item.presentacionId,
            detalle: item.detalle,
            precioCompra: item.precioCompra,
            uriFoto:'',
            precioVenta:'',
          })));
          setPresentaciones(updatedMarcas);
          position.agregar = true;
        }
  
  
        }

       
  
        //console.log("cambio: ", componente.agregar)
  
        //console.log("sistemaid: ",objetos.sistemaId)
        
    }, [store.aPrestaciones]);

       //console.log("TTTT", marcas)


    useEffect(() => {
        //console.log("EEEE", entity.dMarca2, entity.marca2Id);
      
        
        const updatedMarcas = presentaciones.map((item, i) => {
            if (i === presentacionAux.index) {
              return {
                ...item,
                precioCompra: presentacionAux.precioCompra,
                precioVenta: presentacionAux.precioVenta,
              };
            }
            return item;
        });
      
        setPresentaciones(updatedMarcas);
      
        //console.log("Objeto: ", objetos);
        //console.log("SI ENVIO: ", componeteAux);
        
        
        //console.log("DATOS LOCALES: ",marcas);
        
        
        arreglo.dataPresentacion = [...presentaciones];
    
      
        //console.log("DATOS ENVIANDO: ",arreglo.dataComp);
    
    
    }, [presentacionAux]);



    const handleCellChange = (e, index, field) => {
        const updatedMarcas = presentaciones.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              [field]: e.target.value
            };
          }
          return item;
        });
        setPresentaciones(updatedMarcas);
        //console.log(updatedObjetos);
        position.index = index
        //console.log("Indice que envio: ",componente.index)
        //console.log("Indice local: ", index)
    };


    const handleMostrarFormulario = () => {
        if(store.pantalla === true){
          setMostrarFormulario(true);
        }else{
          setMostrarFormulario(false);
        } 
    };

    const onDelete = (index) => {
        setPresentaciones(prevObjetos => prevObjetos.filter((_, i) => i !== index));
    };

    arreglo.dataPresentacion = [...presentaciones];
    
    //console.log("DATOS ENVIANDO: ",arreglo.dataMarca);
    

    return (


        <>

            <Button
                color="primary" 
                size="small" 
                variant="contained"
                onClick={() => {
                dispatch(btnListaPresentaciones());
                handleMostrarFormulario();
                }}
                style = {{width: "170px",
                            marginLeft: "12px",
                            marginTop: "-45px",
                            height: "25px"}}
                        >
                Agregar Presentacion(es)
            </Button>
            {mostrarFormulario && (
        
           <div>
            <br></br>
            <br></br>
            <FieldSet className={classes.paper} iconCls="fas fa-address-card" title="Asignación de Presentacion(es)" >
            <table className={classes.table1}  >
            <thead> 
            <tr>     
                <th style={{textAlign : 'left', width: '2%'}}>  </th>
                <th style={{width: '25%', height:'100%', textAlign : 'center'}}> Presentacion </th>
                <th style={{width: '20%', height:'100%', textAlign : 'center'}}> Detalle </th> 
                <th style={{width: '15%', height:'100%', textAlign : 'center'}}> Precio Compra </th>
                <th style={{width: '15%', height:'100%', textAlign : 'center'}}> Precio Venta </th>
                <th style={{textAlign : 'center', width: '10%'  }}></th>
            </tr>
            </thead>

            <tbody>
                {
                        presentaciones.map((item, i) => (
                            <tr key={i}>
                                <td style={{ width: '2%', height: '100%' }}>{i + 1}</td>
                                <td style={{ width: '20%', height: '100%', textAlign: 'center' }}> 
                                 {item.dPresentacion}
                                </td>
                                <td style={{ width: '20%', height: '100%', textAlign: 'center' }}> 
                                 {item.detalle}
                                </td>
                                <td style={{ width: '10%', height: '100%', textAlign: 'center' }}> 
                                 <TextField name="orden" type="number" value={item.precioCompra} onChange={(e) => handleCellChange(e, i, "precioCompra")} /> 
                                </td>
                                <td style={{ width: '10%', height: '100%', textAlign: 'center' }}> 
                                 <TextField name="orden" type="number" value={item.precioVenta} onChange={(e) => handleCellChange(e, i, "precioVenta")} /> 
                                </td>
                                
                                <td colSpan="2" style={{width: '10px', height:'100%',    textAlign: 'center' }}>
                                {
                                    
                                            <button
                                              style={{ width: 30, backgroundColor: 'white', borderColor: 'darkgray' }}
                                              className={'btn-success'}
                                              icon={'fa-solid fa-arrow-right-to-bracket'}
                                              onClick={() => onDelete(i)}
                                            >
                                              <i className="fas fa-times"></i>
                                            </button>

                                }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>


            </table>
            </FieldSet>
            </div>
             )
        }
        
        </>

    );
};

export default PreciosTable;